import styled from "styled-components";

const NavStyled = styled.nav`
  display: flex;
  align-items: center;
`;

export default NavStyled;
